import { Platform } from '@angular/cdk/platform';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { provideAppConfig } from '@core/config';
import { provideCoreInterceptors, provideCoreStore } from '@core/store';
import { LA_DATE_FORMATS, LaDatePickerAdapter } from '@shared/filters';

import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideCoreStore(),
    provideRouter(appRoutes, withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
    provideCoreInterceptors(),
    provideAppConfig(environment),
    { provide: LOCALE_ID, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: LaDatePickerAdapter, deps: [MAT_DATE_LOCALE, Platform] },
    { provide: MAT_DATE_FORMATS, useValue: LA_DATE_FORMATS },
  ],
};
